<template>
  <component
    :is="getActionLinkComponent(content.target)"
    v-if="!content.hideOnWeb"
    :class="[
      brandClasses.title,
      presets[content.menuStyle!],
      highlightClass,
      { 'cursor-pointer bg-transparent p-0 text-left': isActionLinkOnly(content.target) },
    ]"
    v-bind="getActionLinkAttrs(content.target)"
    @click="$emit('click')"
  >
    <vf-icon v-if="content.menuIcon" :name="content.menuIcon.icon" size="xs" />
    <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" class="underscore" />
    <span v-else class="underscore">{{ content.title }}</span>
  </component>
</template>

<script lang="ts" setup>
import type { MegaMenuL2Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { MegaMenuL2ContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{
  content: MenuItem
}>()

defineEmits<{
  click: []
}>()

const { $feature } = useNuxtApp()
const { getActionLinkAttrs, getActionLinkComponent, isActionLinkOnly } = useCmsActionLink()
const { brandClasses: baseClasses, brandClassesV2, presets } = useAppConfig().components.cms.megaMenuL3Desktop

const { featured, visualSelectors } = inject(MegaMenuL2ContextKey, {} as MegaMenuL2Context)

const brandClasses = computed(() => ({ ...baseClasses, ...($feature.tempMegaMenuDesktopRedesign && brandClassesV2) }))

const highlightClass = computed(() => {
  if (!$feature.tempMegaMenuDesktopRedesign && visualSelectors?.value) return brandClasses.value.visualSelectors
  if (featured) return brandClasses.value.featured
})
</script>
